import React from 'react';
import { SettingsIcon, TrashIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import { SettingsSection } from './SettingsSection';
export const AccountActionsSection: React.FC = () => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  return <SettingsSection icon={<SettingsIcon className={`h-4 w-4 ${rt.textPrimary}`} data-id="element-541" data-mp="ic0cs09qd81m" />} title="Account Actions" subtitle="Manage your account status" data-id="element-540" data-mp="1f1hn4sjnri9n">
      <div className="space-y-4" data-id="element-542" data-mp="meetadpxfvpq">
        <div className={`p-5 rounded-xl border ${dk.isDark ? 'bg-yellow-900/20 border-yellow-700/30' : 'bg-yellow-50 border-yellow-200'}`} data-id="element-543" data-mp="mbixauxn3h3x">
          <h4 className={`text-base font-semibold mb-2 ${dk.isDark ? 'text-yellow-300' : 'text-yellow-800'}`} data-id="element-544" data-mp="w4gfezypz420">
            Account Status
          </h4>
          <p className={`text-sm ${dk.isDark ? 'text-yellow-200/80' : 'text-yellow-700'}`} data-id="element-545" data-mp="3mlycdras0fd">
            Your account is currently active. You can temporarily deactivate
            your account or permanently delete it below.
          </p>
          <div className="mt-4" data-id="element-546" data-mp="2nc0q3wxjav0i">
            <button type="button" className={`px-4 py-2 text-sm font-medium rounded-lg border ${dk.isDark ? 'border-yellow-700/50 text-yellow-300 hover:bg-yellow-900/30' : 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'}`} data-id="element-547" data-mp="2iio47uk8p2bg">
              Deactivate Account
            </button>
          </div>
        </div>
        <div className={`p-5 rounded-xl border ${dk.isDark ? 'bg-red-900/20 border-red-700/30' : 'bg-red-50 border-red-200'}`} data-id="element-548" data-mp="23o1hosqfzzy9">
          <h4 className={`text-base font-semibold mb-2 ${dk.isDark ? 'text-red-300' : 'text-red-800'}`} data-id="element-549" data-mp="1um0l7y319hxn">
            Delete Account
          </h4>
          <p className={`text-sm ${dk.isDark ? 'text-red-200/80' : 'text-red-700'}`} data-id="element-550" data-mp="3oz9z022m3plp">
            Once you delete your account, there is no going back. Please be
            certain.
          </p>
          <div className="mt-4" data-id="element-551" data-mp="gpqwfyzyep3l">
            <button type="button" className="px-4 py-2 text-sm font-medium rounded-lg text-white bg-red-600 hover:bg-red-700" data-id="element-552" data-mp="gq0mtnowuy9t">
              <TrashIcon className="h-4 w-4 mr-2 inline" data-id="element-553" data-mp="7wduy8ntqf5w" />
              Delete Account
            </button>
          </div>
        </div>
      </div>
    </SettingsSection>;
};